<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <a class="small-header-action" href="">
            <div class="clip-header">
              <i class="fa fa-arrow-up"></i>
            </div>
          </a>

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><a href="index.html">Dashboard</a></li>
              <li class="active">
                <span>Notifications</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Notifications
          </h3>
          <small>Historic notifications</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel">
        <div class="v-timeline vertical-container animate-panel" data-child="vertical-timeline-block" data-delay="1">
          <div class="vertical-timeline-block" style="" v-for="(notification, key) in notifications" :key="key">
            <div class="vertical-timeline-icon navy-bg">
              <i class="fa fa-calendar"></i>
            </div>
            <div class="vertical-timeline-content">
              <div class="p-sm">
                <span class="vertical-date pull-right"> {{ notification.created_at |moment('LL')}} <br> <small>{{notification.created_at |moment('LT')}}</small> </span>

                <template v-if="notification.link !== null && notification.link.search('http') === 0">
                  <a :href="notification.link" target="_blank">
                    <h2 :class="{'text-info': notification.link !== null}">{{notification.title}}</h2>
                  </a>
                </template>
                <router-link v-else :to="{ path: (notification.link === null ? '#' : notification.link)}">
                  <h2 :class="{'text-info': notification.link !== null}">{{notification.title}}</h2>
                </router-link>
                <div v-html="notification.content"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  components: {
  },
  name: 'Notifications',
  methods: {
    getResources: function () {
      this.axios.get('notifications').then((response) => {
        this.notifications = response.data
      })
    }
  },
  mounted () {
  },
  data () {
    return {
      notifications: []
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/notification/Notifications.vue